import React, { useState } from "react";

import { useParams } from "react-router-dom";
import useUserProfile from "hooks/useUserProfile";

import IdentityVerification from "./IdentityVerification";
import Modal from "Common/Components/Modal";
import MyndaForm from "../Forms/MyndaForm";
import useKycReport from "hooks/useKycReport";
import { useMutation } from "react-query";
import { verifyKyc } from "services/user.service";

const OverviewTabs = () => {
  const [showUpdateMynda, setShowUpdateMynda] = useState(false);
  const params = useParams();
  const { data, isLoading } = useUserProfile(params.id!);
  const {
    data: report,
    refetch,
    isLoading: loading,
  } = useKycReport(params.id!);

  const { mutate: updateKyc, isLoading: isPending } = useMutation(
    (input: { isVerified: boolean; id: number }) =>
      verifyKyc(params.id!, input.id, input.isVerified),
    {
      onSuccess() {
        refetch();
      },
    }
  );

  const toggleUpdateMynda = () => {
    setShowUpdateMynda(!showUpdateMynda);
  };

  const handleVerification = (value: boolean) => {
    updateKyc({ id: 0, isVerified: value });
  };

  if (isLoading) return <p>Loading...</p>;

  return (
    <div>
      <div className="flex flex-col">
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="card lg:w-[50%]">
            <div className="card-body flex flex-col">
              {!data?.data?.user?.accountVerified && (
                <button
                  onClick={toggleUpdateMynda}
                  className="text-white self-end btn my-5 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Update documents
                </button>
              )}

              <div className=" flex items-center justify-between">
                <h6 className="mb-4 text-15">Personal Information</h6>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full ltr:text-left rtl:ext-right">
                  <tbody>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Area
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.area}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Street
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.street}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        State of Residence
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.residenceState}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        L . G .A
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.residenceLga}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        State of Origin
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.state}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        L . G .A
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.lga}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Sex
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.gender}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Height
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.height}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Category
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.occupation}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Date of birth
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.dob
                          ? new Date(
                              data?.data?.mynda?.dob
                            ).toLocaleDateString()
                          : ""}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Religion
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.religion}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        State willing to relocate to
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.stateCoverage?.toString()}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Disabilities
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.disabilities?.toString()}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Allergies
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.allegies?.toString()}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Uploaded Document
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.docType}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Document Number
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.docNumber}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Document
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.document && (
                          <a
                            href={data?.data?.mynda?.document?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View {data?.data?.mynda?.docType}
                          </a>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        {data?.data?.mynda?.docType}
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.mynda?.document && (
                          <a
                            href={data?.data?.mynda?.document?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {data?.data?.mynda?.docType}
                          </a>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* {loading ? null : (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <button
                      disabled={report?.data[0].verified}
                      onClick={() => handleVerification(true)}
                      className="text-white transition-all duration-200 ease-linear btn disabled:opacity-50 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring mt-8 active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {report?.data[0].verified
                        ? "Verified"
                        : isPending
                        ? "Loading..."
                        : "Click to verify"}
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </div>

          <div className="flex-1">
            <IdentityVerification
              docNumber={data?.data?.mynda?.docNumber!}
              docType={data?.data?.mynda?.docType!}
              userId={data?.data?.user?._id!}
              status={data?.data?.user?.kycStatus!}
              verifiedInfo={data?.data?.user?.verifiedInfo!}
              userProfile={data?.data!}
              userRole="Mynda"
            />
          </div>
        </div>
      </div>

      <Modal
        show={showUpdateMynda}
        onHide={toggleUpdateMynda}
        id="defaultModal"
        modal-center="true"
        size="md"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500"
        >
          <Modal.Title className="text-16">Update Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 overflow-y-auto">
          <MyndaForm
            onCancel={toggleUpdateMynda}
            data={data?.data?.mynda!}
            onSubmit={toggleUpdateMynda}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OverviewTabs;
